import { BrowserModule } from '@angular/platform-browser';
import { LOCALE_ID, NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { MatListModule } from '@angular/material/list'
import { MatIconModule } from '@angular/material/icon'
import { MatToolbarModule } from '@angular/material/toolbar'
import { MatSidenavModule } from '@angular/material/sidenav'
import { MatTabsModule } from '@angular/material/tabs';
import { MatTableModule } from '@angular/material/table';
import { MatGridListModule } from '@angular/material/grid-list';
import { AppComponent } from './app.component';
import { LoginComponent } from './components/login/login.component';
import { JardinComponent } from './components/jardin/jardin.component'
import { PersonaComponent } from './components/persona/persona.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { IdentificacionComponent } from './components/jardin/components/identificacion/identificacion.component'
import { EtapasComponent } from './components/jardin/components/etapas/etapas.component';
import { MatStepperModule } from '@angular/material/stepper';
import { STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatCardModule } from '@angular/material/card';
import { MatChipsModule } from '@angular/material/chips';
import { MatSortModule } from '@angular/material/sort'; 
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatDialogModule } from '@angular/material/dialog';
import { MatRadioModule } from '@angular/material/radio'
import { CronogramaComponent } from './components/jardin/components/cronograma/cronograma.component';
import { DocumentosComponent } from './components/jardin/components/documentos/documentos.component';
import { InicioComponent } from './components/jardin/components/inicio/inicio.component';
import { ModalEditarMiembroComponent } from './components/jardin/components/dialogs/modal-miembros-equipo-pedagogico/modal-miembros-equipo-pedagogico.component';
import { ModalVideoComponent } from './components/jardin/components/dialogs/modal-video/modal-video.component';
import { ContactoComponent } from './components/jardin/components/contacto/contacto.component';
import { ModalCrearConsultaComponent } from './components/jardin/components/dialogs/modal-crear-consulta/modal-crear-consulta.component';
import { DetalleConsultaComponent } from './components/jardin/components/detalle-consulta/detalle-consulta.component';
import { ModalMediosVerificacionComponent } from './components/jardin/components/dialogs/modal-medios-verificacion/modal-medios-verificacion.component';
import { ModalResumenIntentosComponent } from './components/jardin/components/dialogs/modal-resumen-intentos/modal-resumen-intentos.component';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { ModalConfirmarEliminacionComponent } from './components/jardin/components/dialogs/modal-confirmar-eliminacion/modal-confirmar-eliminacion.component';
import { AutoevaluacionComponent } from './components/jardin/components/autoevaluacion-inicio-view/components/autoevaluacion/autoevaluacion.component';
import { EvaluaRequeridosDirective } from './directives/evalua-requeridos.directive';
import { ModalAutoevaluacionMediosVerificacionComponent } from './components/jardin/components/dialogs/modal-autoevaluacion-medios-verificacion/modal-autoevaluacion-medios-verificacion.component';
import { ModalConfirmarComponent } from './components/jardin/components/dialogs/modal-confirmar/modal-confirmar.component';
import { ModalResumenMediosVerificacionComponent } from './components/jardin/components/dialogs/modal-resumen-medios-verificacion/modal-resumen-medios-verificacion.component';
import { ModalResumenEvaluacionComponent } from './components/jardin/components/dialogs/modal-resumen-evaluacion/modal-resumen-evaluacion.component';
import { AdministradorComponent } from './components/administrador/administrador.component';
import { AdministracionComponent } from './components/administrador/components/administracion/administracion.component';
import { ReportesComponent } from './components/administrador/components/reportes/reportes.component';
import { MensajeriaComponent } from './components/administrador/components/mensajeria/mensajeria.component';
import { InicioAdministradorComponent } from './components/administrador/components/inicio-administrador/inicio-administrador.component';
import { RutDirective } from './directives/rut.directive';
import { NumerosDirective } from './directives/numeros.directive';
import { MailDirective } from './directives/mail.directive';
import { ProyectoEducativoComponent } from './components/jardin/components/proyecto-educativo/proyecto-educativo.component';
import { NgxSpinnerModule } from "ngx-spinner";
import { ModalCambiarPassComponent } from './components/jardin/components/dialogs/modal-cambiar-pass/modal-cambiar-pass.component';
import { ModalFichaCuentaComponent } from './components/administrador/components/dialogs/modal-ficha-cuenta/modal-ficha-cuenta.component';
import { ModalFichaUsuarioComponent } from './components/administrador/components/dialogs/modal-ficha-usuario/modal-ficha-usuario.component';
import { CuentasJardinComponent } from './components/administrador/components/administracion/components/cuentas-jardin/cuentas-jardin.component';
import { CuentasUsuarioComponent } from './components/administrador/components/administracion/components/cuentas-usuario/cuentas-usuario.component';
import {StorageService} from "./service/storage.service";
import {AuthorizatedGuard} from "./guard/authorizated.guard";
import { Router } from '@angular/router';
import { DiariomuralComponent } from './components/jardin/components/diariomural/diariomural.component';
import { DialogDataDiarioComponent } from './components/jardin/components/diariomural/dialog-data-diario/dialog-data-diario.component';
import { ConsolidadoComponent } from './components/administrador/components/reportes/components/consolidado/consolidado.component';
import { CapacitacionComponent } from './components/administrador/components/reportes/components/capacitacion/capacitacion.component';
import { CapacitacionPresencialComponent } from './components/administrador/components/reportes/components/capacitacion/components/capacitacion-presencial/capacitacion-presencial.component';
import { CapacitacionDistanciaComponent } from './components/administrador/components/reportes/components/capacitacion/components/capacitacion-distancia/capacitacion-distancia.component';
import { CapacitacionInicioComponent } from './components/administrador/components/reportes/components/capacitacion/components/capacitacion-inicio/capacitacion-inicio.component';
import { ValidacionComponent } from './components/administrador/components/reportes/components/validacion/validacion.component';
import { ValidacionInicioComponent } from './components/administrador/components/reportes/components/validacion/components/validacion-inicio/validacion-inicio.component';
import { ResumenValidacionComponent } from './components/administrador/components/reportes/components/validacion/components/validacion-resumen/resumen-validacion.component';
import { ValidacionSeguimientoComponent } from './components/administrador/components/reportes/components/validacion/components/validacion-seguimiento/validacion-seguimiento.component';
import { ApelacionesSeguimientoComponent } from './components/administrador/components/reportes/components/validacion/components/apelaciones-seguimiento/apelaciones-seguimiento.component';
import { InformeSeguimientoComponent } from './components/administrador/components/reportes/components/validacion/components/informe-seguimiento/informe-seguimiento.component';
import { PlanDeMejoramientoComponent } from './components/administrador/components/reportes/components/plan-de-mejoramiento/plan-de-mejoramiento.component';
import { PlanResumenComponent } from './components/administrador/components/reportes/components/plan-de-mejoramiento/components/plan-resumen/plan-resumen.component';
import { PlanSeguimientoComponent } from './components/administrador/components/reportes/components/plan-de-mejoramiento/components/plan-seguimiento/plan-seguimiento.component';
import { PlanInicioComponent } from './components/administrador/components/reportes/components/plan-de-mejoramiento/components/plan-inicio/plan-inicio.component';
import { InicioCronogramaComponent } from './components/administrador/components/administracion/components/inicio-cronograma/inicio-cronograma.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { AutoEvaluacionComponent } from './components/administrador/components/reportes/components/auto-evaluacion/auto-evaluacion.component';
import { AutoevaluacionResumenComponent } from './components/administrador/components/reportes/components/auto-evaluacion/components/autoevaluacion-resumen/autoevaluacion-resumen.component';
import { AutoevaluacionSeguimientoComponent } from './components/administrador/components/reportes/components/auto-evaluacion/components/autoevaluacion-seguimiento/autoevaluacion-seguimiento.component';
import { VerificacionSeguimientoComponent } from './components/administrador/components/reportes/components/auto-evaluacion/components/verificacion-seguimiento/verificacion-seguimiento.component';
import { DiarioSeguimientoComponent } from './components/administrador/components/reportes/components/auto-evaluacion/components/diario-seguimiento/diario-seguimiento.component';
import { AutoevaluacionInicioComponent } from './components/administrador/components/reportes/components/auto-evaluacion/components/autoevaluacion-inicio/autoevaluacion-inicio.component';
import { InicioJardinComponent } from './components/jardin/components/inicio-jardin/inicio-jardin.component';
import { AulaVirtualComponent } from './components/jardin/components/aula-virtual/aula-virtual.component';
import { TutorComponent } from './components/tutor/tutor.component';
import { InicioTutorComponent } from './components/tutor/components/inicio-tutor/inicio-tutor.component';
import { DisponibilidadComponent } from './components/tutor/components/disponibilidad/disponibilidad.component';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { CommonModule, DatePipe } from '@angular/common';
import { NgbModalModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FlatpickrModule } from 'angularx-flatpickr';
import localeEsCL from '@angular/common/locales/es-CL';
import { registerLocaleData } from '@angular/common';
import { AgendarComponent } from './components/jardin/components/aula-virtual/components/agendar/agendar.component';
import { CapacitacionJardinComponent } from './components/jardin/components/capacitacion-jardin/capacitacion-jardin.component';
import { AutoevaluacionInicioViewComponent } from './components/jardin/components/autoevaluacion-inicio-view/autoevaluacion-inicio-view.component';
import { NotasComponent } from './components/jardin/components/aula-virtual/components/notas/notas.component';
import { NoteComponent } from './components/jardin/components/aula-virtual/components/notas/components/note/note.component';
import { NotasPMComponent } from './components/jardin/components/aula-virtual/components/notasPM/notas-pm.component';
import { NotePMComponent } from './components/jardin/components/aula-virtual/components/notasPM/components/note/note-pm.component';
import { MegaTutorComponent } from './components/mega-tutor/mega-tutor.component';
import { InicioMegaTutorComponent } from './components/mega-tutor/components/inicio-mega-tutor/inicio-mega-tutor.component';
import { TutorCardComponent } from './components/mega-tutor/components/inicio-mega-tutor/tutor-card/tutor-card.component';
import { CapacitacionTutorMoodleComponent } from './components/tutor/components/capacitacion-tutor-moodle/capacitacion-tutor-moodle.component';
import { JardinValidacionExternaComponent } from './components/jardin/components/jardin-validacion-externa/jardin-validacion-externa.component';
import { JardinPlanMejoraComponent } from './components/jardin/components/jardin-plan-mejora/jardin-plan-mejora.component';
import { ProyectoEducativoContextoComponent } from './components/jardin/components/proyecto-educativo/components/proyecto-educativo-contexto/proyecto-educativo-contexto.component';
import { ProyectoEducativoIdearioComponent } from './components/jardin/components/proyecto-educativo/components/proyecto-educativo-ideario/proyecto-educativo-ideario.component';
import { ProyectoEducativoObjectivosComponent } from './components/jardin/components/proyecto-educativo/components/proyecto-educativo-objectivos/proyecto-educativo-objectivos.component';
import { ProyectoEducativoEvaluacionComponent } from './components/jardin/components/proyecto-educativo/components/proyecto-educativo-evaluacion/proyecto-educativo-evaluacion.component';
import { ModalCambiarFotoperfilComponent } from './components/jardin/components/dialogs/modal-cambiar-fotoperfil/modal-cambiar-fotoperfil.component';
import { SimulacionJardinComponent } from './components/tutor/components/inicio-tutor/components/simulacion-jardin/simulacion-jardin.component';
import { PreguntasFrecuentesComponent } from './components/jardin/components/inicio-jardin/components/preguntas-frecuentes/preguntas-frecuentes.component';
import { EquipoPedagogicoComponent } from './components/equipo-pedagogico/equipo-pedagogico.component';
import { ContextoComponent } from './components/jardin/components/autoevaluacion-inicio-view/components/contexto/contexto.component';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import { ApelacionJardinComponent } from './components/jardin/components/jardin-validacion-externa/components/apelacion-jardin/apelacion-jardin.component';
import { ModalEvaluacionConfidencialComponent } from './components/jardin/components/jardin-validacion-externa/components/modal-evaluacion-confidencial/modal-evaluacion-confidencial.component';
import { ModalActaComponent } from './components/jardin/components/jardin-validacion-externa/components/modal-acta/modal-acta.component';
import { FaseEstrategicaComponent } from './components/jardin/components/jardin-plan-mejora/components/fase-estrategica/fase-estrategica.component';
import { AreaFEComponent } from './components/jardin/components/jardin-plan-mejora/components/fase-estrategica/area/area-fe.component';
import { ObjetivosEstrategicosFEComponent } from './components/jardin/components/jardin-plan-mejora/components/fase-estrategica/objetivos-estrategicos-fe/objetivos-estrategicos-fe.component';
import { FaseAnualComponent } from './components/jardin/components/jardin-plan-mejora/components/fase-anual/fase-anual.component';
import { SubdimensionFEComponent } from './components/jardin/components/jardin-plan-mejora/components/fase-estrategica/subdimension-fe/subdimension-fe.component'

import { AccionAnualComponent } from './components/jardin/components/jardin-plan-mejora/components/fase-anual/accion-anual/accion-anual.component';
import { AreaAnualComponent } from './components/jardin/components/jardin-plan-mejora/components/fase-anual/area/area-anual.component';
import { EstrategiaAnualComponent } from './components/jardin/components/jardin-plan-mejora/components/fase-anual/estrategia-anual/estrategia-anual.component';

import { FaseAnualSeguimientoComponent } from './components/jardin/components/jardin-plan-mejora/components/seguimiento-pme/fase-anual-seguimiento.component';
import { AccionAnualSeguimientoComponent} from './components/jardin/components/jardin-plan-mejora/components/seguimiento-pme/accion-anual/accion-anual-seguimiento.component';
import { AreaAnualSeguimientoComponent } from './components/jardin/components/jardin-plan-mejora/components/seguimiento-pme/area/area-anual-seguimiento.component';
import { EstrategiaAnualSeguimientoComponent } from './components/jardin/components/jardin-plan-mejora/components/seguimiento-pme/estrategia-anual/estrategia-anual-seguimiento.component';
import { CapacitacionTutoriasComponent } from './components/administrador/components/reportes/components/capacitacion/components/capacitacion-tutorias/capacitacion-tutorias.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { SimulacionJardinAdministradorComponent } from './components/administrador/components/administracion/components/simulacion-jardin-administrador/simulacion-jardin-administrador.component';
import { HistorialComponent } from './components/jardin/components/historial/historial.component';
import { AdminProyectoEducativoComponent } from './components/administrador/components/reportes/components/admin-proyecto-educativo/admin-proyecto-educativo.component';
import { SubdimensionAnualComponent } from './components/jardin/components/jardin-plan-mejora/components/fase-anual/subdimension-anual/subdimension-anual.component';
import { SubdimensionAnualSeguimientoComponent } from './components/jardin/components/jardin-plan-mejora/components/seguimiento-pme/subdimension-anual/subdimension-anual-seguimiento.component';
import { CuentasEncargadoRegionalComponent } from './components/administrador/components/administracion/components/cuentas-encargado-regional/cuentas-encargado-regional.component';
import { AdministradorRegionalComponent } from './components/administrador-regional/administrador-regional.component';
import { PlanGestionConvivenciaComponent } from './components/jardin/components/plan-gestion-convivencia/plan-gestion-convivencia.component';
import { ReglamentoInternoComponent } from './components/jardin/components/reglamento-interno/reglamento-interno.component';
import { BibliotecaComponent } from './components/jardin/components/biblioteca/biblioteca.component';
import { EstrategiaPgcComponent } from './components/jardin/components/plan-gestion-convivencia/components/estrategia-pgc/estrategia-pgc.component';
import { ActividadPgcComponent } from './components/jardin/components/plan-gestion-convivencia/components/actividad-pgc/actividad-pgc.component';
import { NivelesReglamentoComponent } from './components/jardin/components/reglamento-interno/components/niveles-reglamento/niveles-reglamento.component';
import { CentrosSaludReglamentoComponent } from './components/jardin/components/reglamento-interno/components/centros-salud-reglamento/centros-salud-reglamento.component';
import { InstitucionDenunciaReglamentoComponent } from './components/jardin/components/reglamento-interno/components/institucion-denuncia-reglamento/institucion-denuncia-reglamento.component';
import { CentrosSaludCercanosReglamentoComponent } from './components/jardin/components/reglamento-interno/components/centros-salud-cercanos-reglamento/centros-salud-cercanos-reglamento.component';
import { IdentificacionAntecedentesComponent } from './components/jardin/components/reglamento-interno/components/identificacion-antecedentes/identificacion-antecedentes.component';
import { PlanGestionConvivenciaAdminComponent } from './components/administrador/components/plan-gestion-convivencia-admin/plan-gestion-convivencia-admin.component';
import { ReglamentoInternoAdminComponent } from './components/administrador/components/reglamento-interno-admin/reglamento-interno-admin.component';
import { BibiotecaAdminComponent } from './components/administrador/components/bibioteca-admin/bibioteca-admin.component';
import { PlanMejoraAsesorViewComponent } from './components/administrador-regional/components/plan-mejora-asesor-view/plan-mejora-asesor-view.component';
import { SimulacionPeiComponent } from './components/administrador/components/simulacion/simulacion-pei/simulacion-pei.component';
import { SimulacionPgcComponent } from './components/administrador/components/simulacion/simulacion-pgc/simulacion-pgc.component';
import { SimulacionReglamentoInternoComponent } from './components/administrador/components/simulacion/simulacion-reglamento-interno/simulacion-reglamento-interno.component';
import { SimulacionPlanMejoraComponent } from './components/administrador/components/simulacion/simulacion-plan-mejora/simulacion-plan-mejora.component';
import { ResultadosSeicepComponent } from './components/jardin/components/resultados-seicep/resultados-seicep.component';
import { InstrumentoAutoevaluacionComponent } from './components/jardin/components/instrumento-autoevaluacion/instrumento-autoevaluacion.component';
import { InsAutoevaluacionDimensionComponent } from './components/jardin/components/instrumento-autoevaluacion/components/ins-autoevaluacion-dimension/ins-autoevaluacion-dimension.component';
import { InsAutoevaluacionSubdimensionComponent } from './components/jardin/components/instrumento-autoevaluacion/components/ins-autoevaluacion-subdimension/ins-autoevaluacion-subdimension.component';
import { InstrumentoAutoevaluacionAdminComponent } from './components/administrador/components/instrumento-autoevaluacion-admin/instrumento-autoevaluacion-admin.component';
import { SimulacionInstrumentoAutoevaluacionComponent } from './components/administrador/components/simulacion/simulacion-instrumento-autoevaluacion/simulacion-instrumento-autoevaluacion.component';
import { NewPmeComponent } from './components/jardin/components/new-pme/new-pme.component';
import { PmeFaseEstrategicaComponent } from './components/jardin/components/new-pme/components/pme-fase-estrategica/pme-fase-estrategica.component';
import { PmeDimensionesComponent } from './components/jardin/components/new-pme/components/pme-fase-estrategica/components/pme-dimensiones/pme-dimensiones.component';
import { PmeSubdimensionesComponent } from './components/jardin/components/new-pme/components/pme-fase-estrategica/components/pme-subdimensiones/pme-subdimensiones.component';
import { PmeFaseAnualComponent } from './components/jardin/components/new-pme/components/pme-fase-anual/pme-fase-anual.component';
import { PmeDimensionesFaseAnualComponent } from './components/jardin/components/new-pme/components/pme-fase-anual/components/pme-dimensiones-fase-anual/pme-dimensiones-fase-anual.component';
import { PmeSubdimensionesFaseAnualComponent } from './components/jardin/components/new-pme/components/pme-fase-anual/components/pme-subdimensiones-fase-anual/pme-subdimensiones-fase-anual.component';
import { PmeEstrategia1FaseAnualComponent } from './components/jardin/components/new-pme/components/pme-fase-anual/components/pme-estrategia1-fase-anual/pme-estrategia1-fase-anual.component';
import { PmeEstrategia2FaseAnualComponent } from './components/jardin/components/new-pme/components/pme-fase-anual/components/pme-estrategia2-fase-anual/pme-estrategia2-fase-anual.component';
import { NewPmeAdminComponent } from './components/administrador/components/reportes/components/new-pme-admin/new-pme-admin.component';
import { SimulacionNewPmeComponent } from './components/administrador/components/simulacion/simulacion-new-pme/simulacion-new-pme.component';
import { PreviewComponent } from './components/preview/preview.component';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { SpinnerService } from './components/spinner/spinner.service';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { AlertDialog } from './components/alert-dialog/alert-dialog.component';
import { MantenedorPEIComponent } from './components/administrador/components/administracion/components/mantenedor-pei/mantenedor-pei.component';
import { MantenedorRIComponent } from './components/administrador/components/administracion/components/mantenedor-ri/mantenedor-ri.component';
import { ModalRecuperarPasswordComponent } from './components/jardin/components/dialogs/modal-recuperar-password/modal-recuperar-password.component';
import { MedicionSatisfaccionComponent } from './components/jardin/components/medicion-satisfaccion/medicion-satisfaccion.component'
import { SeicepResultados2025Component } from './components/jardin/components/resultados-seicep/components/seicep-resultados2025/seicep-resultados2025.component';
import { SeicepResultados2024Component } from './components/jardin/components/resultados-seicep/components/seicep-resultados2024/seicep-resultados2024.component'


registerLocaleData(localeEsCL, 'es'); 

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    JardinComponent,
    PersonaComponent,
    IdentificacionComponent,
    EtapasComponent,
    CronogramaComponent,
    DocumentosComponent,
    InicioComponent,
    ModalEditarMiembroComponent,
    ModalVideoComponent,
    ContactoComponent,
    ModalCrearConsultaComponent,
    DetalleConsultaComponent,
    ModalMediosVerificacionComponent,
    ModalResumenIntentosComponent,
    ModalConfirmarEliminacionComponent,
    AutoevaluacionComponent,
    EvaluaRequeridosDirective,
    ModalAutoevaluacionMediosVerificacionComponent,
    ModalConfirmarComponent,
    ModalResumenMediosVerificacionComponent,
    ModalResumenEvaluacionComponent,
    AdministradorComponent,
    AdministracionComponent,
    ReportesComponent,
    MensajeriaComponent,
    InicioAdministradorComponent,
    RutDirective,
    NumerosDirective,
    MailDirective,
    ProyectoEducativoComponent,
    ModalCambiarPassComponent,
    ModalFichaCuentaComponent,
    ModalFichaUsuarioComponent,
    CuentasJardinComponent,
    CuentasUsuarioComponent,
    DiariomuralComponent,
    DialogDataDiarioComponent,
    ConsolidadoComponent,
    CapacitacionComponent,
    CapacitacionPresencialComponent,
    CapacitacionDistanciaComponent,
    CapacitacionInicioComponent,
    ValidacionComponent,
    ValidacionInicioComponent,
    ResumenValidacionComponent,
    ValidacionSeguimientoComponent,
    ApelacionesSeguimientoComponent,
    InformeSeguimientoComponent,
    PlanDeMejoramientoComponent,
    PlanResumenComponent,
    PlanSeguimientoComponent,
    PlanInicioComponent,
    InicioCronogramaComponent,
    AutoEvaluacionComponent,
    AutoevaluacionResumenComponent,
    AutoevaluacionSeguimientoComponent,
    VerificacionSeguimientoComponent,
    DiarioSeguimientoComponent,
    AutoevaluacionInicioComponent,
    InicioJardinComponent,
    AulaVirtualComponent,
    TutorComponent,
    InicioTutorComponent,
    DisponibilidadComponent,
    AgendarComponent,
    CapacitacionJardinComponent,
    AutoevaluacionInicioViewComponent,
    NotasComponent,
    NoteComponent,
    NotasPMComponent,
    NotePMComponent,
    MegaTutorComponent,
    TutorCardComponent,
    InicioMegaTutorComponent,
    CapacitacionTutorMoodleComponent,
    JardinValidacionExternaComponent,
    JardinPlanMejoraComponent,
    ProyectoEducativoContextoComponent,
    ProyectoEducativoIdearioComponent,
    ProyectoEducativoObjectivosComponent,
    ProyectoEducativoEvaluacionComponent,
    ModalCambiarFotoperfilComponent,
    SimulacionJardinComponent,
    PreguntasFrecuentesComponent,
    EquipoPedagogicoComponent,
    ContextoComponent,
    ModalActaComponent,
    ModalEvaluacionConfidencialComponent,
    ApelacionJardinComponent,
    FaseEstrategicaComponent,
    AreaFEComponent,
    ObjetivosEstrategicosFEComponent,
    FaseAnualComponent,
    AccionAnualComponent,
    AreaAnualComponent,
    EstrategiaAnualComponent,
    FaseAnualSeguimientoComponent,
    AccionAnualSeguimientoComponent,
    AreaAnualSeguimientoComponent,
    EstrategiaAnualSeguimientoComponent,
    CapacitacionTutoriasComponent,
    SimulacionJardinAdministradorComponent,
    HistorialComponent,
    AdminProyectoEducativoComponent,
    SubdimensionFEComponent,
    SubdimensionAnualComponent,
    SubdimensionAnualSeguimientoComponent,
    CuentasEncargadoRegionalComponent,
    AdministradorRegionalComponent,
    PlanGestionConvivenciaComponent,
    ReglamentoInternoComponent,
    BibliotecaComponent,
    EstrategiaPgcComponent,
    ActividadPgcComponent,
    NivelesReglamentoComponent,
    CentrosSaludReglamentoComponent,
    InstitucionDenunciaReglamentoComponent,
    CentrosSaludCercanosReglamentoComponent,
    IdentificacionAntecedentesComponent,
    PlanGestionConvivenciaAdminComponent,
    ReglamentoInternoAdminComponent,
    BibiotecaAdminComponent,
    PlanMejoraAsesorViewComponent,
    SimulacionPeiComponent,
    SimulacionPgcComponent,
    SimulacionReglamentoInternoComponent,
    SimulacionPlanMejoraComponent,
    ResultadosSeicepComponent,
    InstrumentoAutoevaluacionComponent,
    InsAutoevaluacionDimensionComponent,
    InsAutoevaluacionSubdimensionComponent,
    InstrumentoAutoevaluacionAdminComponent,
    SimulacionInstrumentoAutoevaluacionComponent,
    NewPmeComponent,
    PmeFaseEstrategicaComponent,
    PmeDimensionesComponent,
    PmeSubdimensionesComponent,
    PmeFaseAnualComponent,
    PmeDimensionesFaseAnualComponent,
    PmeSubdimensionesFaseAnualComponent,
    PmeEstrategia1FaseAnualComponent,
    PmeEstrategia2FaseAnualComponent,
    NewPmeAdminComponent,
    SimulacionNewPmeComponent,
    PreviewComponent,
    SpinnerComponent,
    AlertDialog,
    MantenedorPEIComponent,
    MantenedorRIComponent,
    ModalRecuperarPasswordComponent,
    MedicionSatisfaccionComponent,
    SeicepResultados2025Component,
    SeicepResultados2024Component
  ],
  imports: [
    MatNativeDateModule,
    MatDatepickerModule,
    BrowserModule,
    AppRoutingModule,
    ReactiveFormsModule,
    HttpClientModule,
    BrowserAnimationsModule,
    MatListModule,
    MatIconModule,
    MatToolbarModule,
    MatSidenavModule,
    MatTabsModule,
    MatTableModule,
    MatGridListModule,
    MatStepperModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    MatExpansionModule,
    MatCardModule,
    MatChipsModule,
    MatSortModule,
    MatDialogModule,
    MatRadioModule,
    MatInputModule,
    MatSlideToggleModule,
    MatSelectModule,
    MatCheckboxModule,
    NgxSpinnerModule,
    MatPaginatorModule,
    CommonModule,
    NgbModalModule,
    NgbModule,
    PdfViewerModule,
    //NgbModule,
    //NgbdPopoverBasicModule,
    //NgbPopover,
    MatSnackBarModule,
    FormsModule, 
    FlatpickrModule.forRoot(),
    CalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: adapterFactory,
    }),
    NgxPaginationModule 
  ],
  providers: [
    StorageService,
    SpinnerService,
    AuthorizatedGuard,
    [DatePipe],
    {provide: STEPPER_GLOBAL_OPTIONS,useValue: { displayDefaultIndicatorType: false,}},
    {provide: LOCALE_ID, useValue: 'es-CL'}
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor(storageService: StorageService, router: Router) {
    if (!storageService.isAuthenticated()) {
      router.navigate(['login']);
    }else if(storageService.getCurrentSession().perfil === 'us_jardin'){
      router.navigate(['jardin']);
    }else if(storageService.getCurrentSession().perfil === 'Administrador'){
      router.navigate(['administrador']);
    }else if(storageService.getCurrentSession().perfil === 'tutor'){
      router.navigate(['tutor']);
    }else if(storageService.getCurrentSession().perfil === 'mega-tutor'){
      router.navigate(['mega-tutor']);
    }else if(storageService.getCurrentSession().perfil === 'asesor-tecnico'){
      router.navigate(['asesor-tecnico']);
    }

    
  }
 }
